import React, { useState, useContext } from "react";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import fileContext from "../../context/fileContext";
import { useDarkMode } from "../../context/darkModeContext";
import { useFolderStore } from "../../store/folderStore";

// images
const Danger = `${process.env.PUBLIC_URL}/assets/danger.webp`;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DeleteRestoreFolder = ({ id, folderName, owner, remove }) => {
  const { darkMode } = useDarkMode();
  const { setRefreshRecycleBin } = useContext(fileContext);
  const restoreFolder = useFolderStore((state) => state.restoreFolder);

  const deleteFolderForever = useFolderStore(
    (state) => state.deleteFolderForever
  );

  // const restoreFolderLocally = useFolderStore(
  //   (state) => state.restoreFolderLocally
  // );

  const setRefreshFolders = useFolderStore((state) => state.setRefreshFolders);

  const setRefreshRecycleFolders = useFolderStore(
    (state) => state.setRefreshRecycleFolders
  );

  const [open, setOpen] = useState(false);

  const [loadingRestore, setLoadingRestore] = useState(false);

  const [loadingDelete, setLoadingDelete] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [severity, setSeverity] = useState("success");

  const [message, setMessage] = useState("");

  const showToast = (type, text) => {
    setSeverity(type);
    setMessage(text);
    setSnackbarOpen(true);
  };

  const closeDialog = () => {
    if (loadingDelete || loadingRestore) return;

    setOpen(false);
  };

  const handleRestore = async () => {
    setLoadingRestore(true);

    try {
      await restoreFolder(id);

      setRefreshRecycleBin(true);

      // restoreFolderLocally(id);

      remove?.(id);

      setRefreshFolders(true);

      setRefreshRecycleFolders(true);

      showToast("success", "Folder restored successfully.");

      setTimeout(() => {
        setOpen(false);
      }, 700);
    } catch (error) {
      console.error(error);

      showToast(
        "error",
        error?.response?.data?.detail || "Unable to restore folder."
      );
    } finally {
      setLoadingRestore(false);
    }
  };

  const handlePermanentDelete = async () => {
    setLoadingDelete(true);

    try {
      await deleteFolderForever(id);

      setRefreshRecycleBin(true);

      // restoreFolderLocally(id);

      remove?.(id);

      setRefreshRecycleFolders(true);

      showToast("success", "Folder permanently deleted.");

      setTimeout(() => {
        setOpen(false);
      }, 700);
    } catch (error) {
      console.error(error);

      showToast(
        "error",
        error?.response?.data?.detail || "Unable to delete folder."
      );
    } finally {
      setLoadingDelete(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="w-full text-left">
        Restore / Delete
      </button>

      <Dialog open={open} onClose={closeDialog} maxWidth="xs" fullWidth>
        <DialogContent className={darkMode ? "bg-gray-900 text-white" : ""}>
          <div className="flex flex-col items-center">
            <img src={Danger} alt="" className="w-24 h-24" />

            <h2 className="text-xl font-bold mt-4">{folderName}</h2>

            <p className="text-center mt-3 text-sm opacity-80">
              Restore this folder or permanently delete it.
            </p>

            <div className="flex flex-col gap-3 mt-6 w-full">
              <button
                disabled={loadingRestore || loadingDelete}
                onClick={handleRestore}
                className="rounded-lg bg-green-600 text-white py-2"
              >
                {loadingRestore ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  "Restore Folder"
                )}
              </button>

              <button
                disabled={loadingRestore || loadingDelete}
                onClick={handlePermanentDelete}
                className="rounded-lg bg-red-600 text-white py-2"
              >
                {loadingDelete ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  "Delete Permanently"
                )}
              </button>

              <button
                disabled={loadingRestore || loadingDelete}
                onClick={closeDialog}
                className="rounded-lg border py-2"
              >
                Cancel
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert severity={severity} onClose={() => setSnackbarOpen(false)}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteRestoreFolder;
